export default __webpack_public_path__ + "static/media/icon-points.83c46924.svg";